import { useState } from 'react'
import { mutations } from '../../resources'
import actions from '../../store/actions'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'
import { UpdateUserRequest, User } from '../../resources/auth/types'

export const useUpdateUser = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const updateUser = (payload: UpdateUserRequest): Promise<User> => {
        setInProgress(true)
        return mutations
            .updateUser(payload)
            .then((response) => {
                dispatch(actions.setUser(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        updateUser,
        inProgress,
    }
}
